import { FC } from "react"
import { DotProps } from "recharts"

export const RenderEventDot: FC<
  DotProps & {
    events?: number
  }
> = (props) => {
  if (props.cx && props.cy && "xAxis" in props) {
    const overrideY = (props.xAxis as unknown as { y: number }).y
    return (
      <g cursor="pointer">
        <circle
          cx={props.cx}
          cy={overrideY}
          fill="var(--mantine-color-error-0)"
          r={8}
        />
        <text
          x={props.cx}
          y={overrideY}
          textAnchor="middle"
          dominantBaseline="middle"
          fill="white"
          fontSize="10"
          fontWeight={600}
        >
          {props.events && props.events > 9 ? "9+" : (props.events ?? 0)}
        </text>
      </g>
    )
  }
  return null
}
